import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TLogin = {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  mutate: (accessToken: string) => void;
};

function useLogout(): TLogin {
  const sdk = useApiSDK();
  const queryClient = useQueryClient();

  const { isError, isLoading, isSuccess, mutate } = useMutation({
    mutationFn: async (accessToken: string) => {
      await sdk.auth.logout(accessToken);
    },
    onSuccess: async () => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('accessTokenExp');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('lastAddedPoint');
      localStorage.removeItem('lastActivityTime');
      localStorage.removeItem('companyId');
      localStorage.removeItem('areaId');
      queryClient.clear();
    },
  });

  return { isError, isLoading, isSuccess, mutate };
}

export { useLogout };
